<!--
 * @Author: wh
 * @Date: 2020-07-02 10:09:52
 * @LastEditTime: 2021-05-27 18:36:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\retailAccount\retailAccountInfo.vue
-->
<template>
    <div class="commonFormStyles retailAccountInfo">
        <van-nav-bar
            title="查看"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <section class="van-pull-refresh showFontBtn">
            <van-collapse v-model="activeNames">
                <van-collapse-item name="1">
                    <div slot="title" class="title">
                        <i class="iconfont icondingdan"></i>工程信息
                    </div>
                    <van-cell-group>
                        <van-cell
                            title="业务编号"
                            :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            :value="formData.contract_number"
                        ></van-cell>
                        <van-cell
                            title="登记时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            :value="formData.register_time"
                        ></van-cell>
                        <van-cell
                            title="工程名称"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                            :value="formData.engineering_name"
                        ></van-cell>
                        <van-cell
                            title="工程类型"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            :value="formData.engineering_type_name"
                        ></van-cell>
                        <van-cell
                            title="标段"
                            :icon="require('@/assets/images/icons/icon_2.png')"
                            :value="formData.section"
                        ></van-cell>
                        <van-cell
                            title="工程地址"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            :value="formData.engineering_location"
                        ></van-cell>
                    </van-cell-group>
                </van-collapse-item>
                <van-collapse-item name="2">
                    <div slot="title" class="title">
                        <i class="iconfont iconlianxiren"></i>联系人信息
                    </div>
                    <van-cell-group>
                        <van-cell
                            title="客户名称"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            :value="formData.client_name"
                        ></van-cell>
                        <van-cell
                            title="客户类型"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            :value="formData.client_type_name"
                        ></van-cell>
                        <van-cell
                            title="统一社会信用代码"
                            :icon="require('@/assets/images/icons/icon_33.png')"
                            :value="formData.client_uscc"
                        ></van-cell>
                        <van-cell
                            title="客户联系人"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            :value="formData.client_contact_name"
                        ></van-cell>
                        <van-cell
                            title="联系电话"
                            :icon="require('@/assets/images/icons/icon_4.png')"
                            :value="formData.client_contact_phone"
                        ></van-cell>
                        <van-cell
                            title="业务员"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            :value="formData.salesman_name"
                        ></van-cell>
                        <van-cell
                            title="业务员电话"
                            :icon="require('@/assets/images/icons/icon_4.png')"
                            :value="formData.salesman_phone"
                        ></van-cell>
                        <van-cell
                            title="供货站点"
                            :icon="require('@/assets/images/icons/icon_3.png')"
                            :value="formData.supply_site_name"
                        ></van-cell>
                        <van-cell
                            title="销售区域"
                            :icon="require('@/assets/images/icons/icon_21.png')"
                            :value="formData.area_name"
                        ></van-cell>
                        <van-cell
                            title="方量（m³）"
                            :icon="require('@/assets/images/icons/icon_6.png')"
                            :value="formData.projected_capacity"
                        ></van-cell>
                        <van-cell
                            title="单价（元）"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                            :value="formData.price"
                        ></van-cell>
                        <van-cell
                            title="金额（万元）"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                            :value="formData.amount_money"
                        ></van-cell>
                        <van-cell
                            title="支付方式"
                            :icon="require('@/assets/images/icons/icon_20.png')"
                            :value="formData.payment_mode_name"
                        ></van-cell>
                        <van-cell
                            title="是否到账"
                            :icon="require('@/assets/images/icons/icon_20.png')"
                        >
                            <template #default>
                                <van-switch
                                    v-model="formData.is_payment"
                                    size="20px"
                                    readonly
                                ></van-switch>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-collapse-item>
                <van-collapse-item name="3">
                    <div slot="title" class="title">
                        <i class="iconfont icondingdan"></i>其他信息
                    </div>
                    <van-cell-group>
                        <van-cell
                            title="强度等级"
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                            :value="formData.strength_grade_name"
                        ></van-cell>
                        <van-cell
                            title="附加型号"
                            :icon="require('@/assets/images/icons/icon_6.png')"
                            :value="formData.additional_model_name"
                        ></van-cell>
                        <van-cell
                            title="浇筑部位"
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                            :value="formData.casting_parts_name"
                        ></van-cell>
                        <van-cell
                            title="浇筑方式"
                            :icon="require('@/assets/images/icons/icon_32.png')"
                            :value="formData.pouring_way_name"
                        ></van-cell>
                        <van-cell
                            title="泵车类型"
                            :icon="require('@/assets/images/icons/icon_32.png')"
                            :value="formData.pump_truck_name"
                        ></van-cell>
                        <van-cell
                            title="泵送单价"
                            class="custom-field"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        >
                            <template #default>
                                <input
                                    placeholder="请输入"
                                    :value="formData.pump_supplement_price"
                                    type="text"
                                >
                                <span>
                                    元/m³
                                </span>
                            </template>
                        </van-cell>
                        <van-cell
                            title="泵送补充模式"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            class="trans-types"
                        >
                            <template #default>
                                <div>
                                    <van-radio-group
                                        v-model="formData.pump_complementary_model"
                                        direction="horizontal"
                                        disabled
                                    >
                                        <van-radio :name="1" icon-size="16px">
                                            补方
                                        </van-radio>
                                        <van-radio :name="2" icon-size="16px">
                                            补固定金额
                                        </van-radio>
                                    </van-radio-group>
                                </div>
                                <div class="custom-row" v-if="formData.pump_complementary_model===1">
                                    <span>不足</span>
                                    <input
                                        v-model="formData.pump_insufficient"
                                        type="number"
                                        disabled
                                    >
                                    <span>按</span>
                                    <input
                                        v-model="formData.pump_add_quantity"
                                        type="number"
                                        disabled
                                    >
                                    方计算。
                                </div>
                                <div class="custom-row" v-if="formData.pump_complementary_model===2">
                                    <span>不足</span>
                                    <input
                                        v-model="formData.pump_insufficient"
                                        type="number"
                                        disabled
                                    >
                                    <span>收取</span>
                                    <input
                                        v-model="formData.pump_add_quantity"
                                        type="number"
                                        disabled
                                    >
                                    元。
                                </div>
                            </template>
                        </van-cell>
                        <van-cell
                            title="浇筑部位描述"
                            :icon="require('@/assets/images/icons/icon_32.png')"
                            :value="formData.casting_parts_desc"
                        ></van-cell>
                        <van-cell
                            title="塌落度"
                            :icon="require('@/assets/images/icons/icon_16.png')"
                        >
                            <template #default>
                                <input
                                    type="text"
                                    class="slump slump1"
                                    :value="formData.slumps"
                                    readonly
                                >
                                ±
                                <input
                                    type="text"
                                    :value="formData.slumps_float"
                                    class="slump"
                                    readonly
                                >
                            </template>
                        </van-cell>
                        <van-cell
                            title="用料时间"
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                            :value="formData.used_materials_time"
                        ></van-cell>
                        <van-cell
                            title="运距（km）"
                            :icon="require('@/assets/images/icons/icon_11.png')"
                            :value="formData.haul_distance"
                        ></van-cell>
                        <van-cell
                            title="运费"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                            :value="formData.freight"
                        ></van-cell>
                        <van-cell
                            title="基础运费"
                            class="custom-field"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        >
                            <template #default>
                                <input
                                    placeholder="请输入"
                                    :value="formData.freight_supplement_price"
                                    type="text"
                                    disabled
                                >
                                <span>
                                    元/m³
                                </span>
                            </template>
                        </van-cell>
                        <van-cell
                            title="运费补充模式"
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            class="trans-types"
                        >
                            <template #default>
                                <div>
                                    <van-radio-group
                                        v-model="formData.freight_complementary_model"
                                        direction="horizontal"
                                        disabled
                                    >
                                        <van-radio :name="1" icon-size="16px">
                                            补方
                                        </van-radio>
                                        <van-radio :name="2" icon-size="16px">
                                            补固定金额
                                        </van-radio>
                                    </van-radio-group>
                                </div>
                                <div class="custom-row" v-if="formData.freight_complementary_model===1">
                                    <span>每车不足</span>
                                    <input
                                        v-model="formData.freight_insufficient"
                                        type="number"
                                        disabled
                                    >
                                    <span>方，按</span>
                                    <input
                                        v-model="formData.freight_add_quantity"
                                        type="number"
                                        disabled
                                    >
                                    方收取费用。
                                </div>
                                <div class="custom-row" v-if="formData.freight_complementary_model===2">
                                    <span>单次方不足</span>
                                    <input
                                        v-model="formData.freight_insufficient"
                                        type="number"
                                        disabled
                                    >
                                    <span>方，按实际方量价格结算后加收</span>
                                    <input
                                        v-model="formData.freight_add_money"
                                        type="number"
                                        disabled
                                    >
                                    元。
                                </div>
                            </template>
                        </van-cell>
                    </van-cell-group>
                    <van-field
                        label="润泵砂浆价格"
                        :left-icon="require('@/assets/images/icons/icon_26.png')"
                        input-align="right"
                        readonly
                        clickable
                    ></van-field>
                    <van-field
                        class="trans-types"
                    >
                        <template #input>
                            <div>
                                <van-radio-group
                                    v-model="formData.mortar_price_type"
                                    direction="horizontal"
                                    disabled
                                >
                                    <van-radio :name="0" icon-size="16px">
                                        与产品同价
                                    </van-radio>
                                    <van-radio :name="1" icon-size="16px">
                                        与产品不同价
                                    </van-radio>
                                </van-radio-group>
                            </div>
                            <div class="custom-row" v-if="formData.mortar_price_type===1">
                                <span>单次方不足</span>
                                <input
                                    v-model="formData.mortar_price_percent"
                                    type="number"
                                    disabled
                                >
                                <span>%产品价</span>
                                <input
                                    v-model="formData.mortar_price"
                                    type="number"
                                    disabled
                                >
                                元/方
                            </div>
                        </template>
                    </van-field>
                    <van-field
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="80"
                        class="iconfont iconbeizhu textarea"
                        :value="formData.remarks"
                        readonly
                    ></van-field>
                    <van-field
                        :left-icon="require('@/assets/images/icons/icon_24.png')"
                        label="附件"
                        placeholder="查看附件"
                        input-align="right"
                        readonly
                        clickable
                        is-link
                        @click="toUpload"
                    >
                    </van-field>
                </van-collapse-item>
            </van-collapse>
        </section>
        <footer class="commonFormBtns">
            <van-button type="info" @click="onClickRight">
                审批进度
            </van-button>
        </footer>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    name: 'retail-account-info',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/retailAccountList') {
            this.$store.commit('noKeepAlive', 'retail-account-info');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 折叠面板-选中
            activeNames: ['1', '2', '3'],
            // 表单数据
            formData: {},
            // 流程信息
            businessProcess: {},
        };
    },
    watch: {},
    computed: {},
    created() {},
    activated() {
    },
    mounted() {
        const contractNumber = this.$route.params.contractNumber;
        this.getRetailDetail(contractNumber);
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/retailAccountList' });
        },
        // 审批进度
        async onClickRight() {
            const res = await this.getBusinessProcessApi();
            if (res) {
                const data = res;
                const isReadOnly = true;
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'approvalProcess',
                    params: {
                        data: data,
                        isReadOnly: isReadOnly,
                    },
                });
            } else {
                Toast('获取流程信息失败！');
            }
        },
        // 上传附件
        toUpload() {
            let BusinessInstanceId = '';
            BusinessInstanceId = this.formData.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'fileUpload',
                params: {
                    formData: this.formData,
                    BusinessInstanceId: BusinessInstanceId,
                    isView: true,
                    fromPath: 'retailAccountInfo',
                    title: '附件资料',
                },
            });
        },
        // 获取零售业务台账明细
        getRetailDetail(contractNumber) {
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_retail_detail/' + contractNumber)
                .then(res => {
                    if (res) {
                        this.formData = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取办理过程信息
        getBusinessProcessApi() {
            const path = '/interfaceApi/basicplatform/simpleflow/processes/last_transaction_model/' + this.formData.business_instance_id;
            return this.$axios.$get(path, { defEx: true });
        },
    },

};
</script>
<style lang="stylus">
.retailAccountInfo
    height 100%
    position relative
    section
        .trans-types
            .van-field__control--custom
                display block
                .van-radio-group
                    margin-bottom 10rpx
            .custom-row
                margin-bottom 10rpx
                input
                    width 50rpx
                    border 0
                    border-bottom 1px solid #ccc
                    margin 0 10rpx
                    height 20rpx
                    text-align center
        .custom-field
            .van-cell__value
                input
                    border none
                    margin-right 5rpx
                    &::webkit-input-placeholder
                        color #ddd
        .star
            .van-cell__title
                &:after
                    content '*'
                    color #E60000
        .slump
            display inline-block
            width 30%
            border none
            text-align: center
</style>
